import {Component, Inject, Input} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DialogButtonTypesEnum, DialogConfigInterface} from 'appShared/components';
import {ApiError, ExchangeModel, SesService} from '@spa/api';
import {RemoveExchangeForm} from 'appEntries/panel/forms';
import {ExchangeAddMessages} from 'appAssets/messages';
import {AlertsService} from 'appShared/services';
import {ExchangeFormErrorStatesEnum} from 'appEntries/panel/enums';
import {PermissionRuleCheckStrategiesEnum} from 'appShared/enums';
import {PermissionRulesTrait} from 'appEntries/panel/traits';
import {PanelBaseMarketDataFormDialogComponent} from 'appEntries/panel/dialogs/ses/panel-base-market-data-form-dialog.component';

@Component({
    selector: 'app-exchange-remove',
    templateUrl: './exchange-remove.component.html',
    styleUrls: ['./exchange-remove.component.scss']
})
export class ExchangeRemoveComponent extends PanelBaseMarketDataFormDialogComponent<ExchangeRemoveComponent> {
    @Input() public exchanges: ExchangeModel[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            config: DialogConfigInterface,
            exchanges: ExchangeModel[]
        },
        private readonly sesService: SesService,
        protected alertsService: AlertsService,
        public dialogRef: MatDialogRef<ExchangeRemoveComponent>,
    ) {
        super(dialogRef, alertsService);
        this.permissionRule = PermissionRulesTrait.getMarketDataFeedManagementPermissionRule(PermissionRuleCheckStrategiesEnum.Union);
        this.config = data.config;
        this.exchanges = data.exchanges;
    }

    initForm(): void {
        this.form = new RemoveExchangeForm(this.sesService, this.exchanges);
        this.form.initForm();

        const formChangeSubscription = this.form.formGroup.valueChanges.subscribe((data: object) => {
            const selectedBundleFirstIndex = Object.keys(data).findIndex((key: string) => data[key] > 0);
            this.config.buttons.find(button => button.type === DialogButtonTypesEnum.Confirm).hidden = selectedBundleFirstIndex < 0;
        });

        this.subscriptions.push(formChangeSubscription);
    }

    getSuccessFormMessage(): string {
        return ExchangeAddMessages.ExchangeDeletionSucceed.message;
    }

    getErrorMessageByApiError(error: ApiError) {
        if (error.status === ExchangeFormErrorStatesEnum.DeleteExchangeFailed) {
            return ExchangeAddMessages.ExchangeDeletionFailed.message;
        }

        return ExchangeAddMessages.UnknownError.message;
    }
}
